import { useId, useRef, useState } from 'react';
import { Box, Menu, MenuItem } from '@mui/material';
import { MenuButton } from '@baseComponents/index';

type MenuItem = {
  label: string;
  onClick: () => void
};

type DropdownMenuButtonProps = {
  label: string;
  items: MenuItem[];
  onClick?: () => void;
}

const DropdownMenuButton = ({ label, items, onClick }: DropdownMenuButtonProps) => {
  const id = useId();
  const buttonId = `${id}-button`;
  const menuId = `${id}-menu`;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const buttonContainerRef = useRef<HTMLDivElement>(null);

  const handleOpen = () => {
    setAnchorEl(buttonContainerRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      ref={buttonContainerRef}
      sx={{
        display: "inline-block"
      }}
    >
      <MenuButton
        text={label}
        onClick={onClick}
        onArrowClick={handleOpen}
      />
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': buttonId,
          },
        }}
      >
        {items.map((item) => {
          return (
            <MenuItem
              key={item.label}
              onClick={() => {
                item.onClick();
                handleClose();
              }}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );

};

export default DropdownMenuButton;
